// @flow
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Header, Footer, setErrorPlacementDefault } from '@cmsgov/ds-healthcare-gov';
import IncomeCalculator from './IncomeCalculator';

setErrorPlacementDefault('bottom');

const handleSkipNav = (event) => {
  event.preventDefault();
  const main = document.getElementById('main-body-content');
  if (main) main.focus();
};

function App(props) {
  return (
    <div className="ds-base">
      <Header
        initialLanguage={props.locale}
        subhead={' '}
        subpath="income-calculator/"
        skipNavHref="#main-body-content"
        onSkipNavClick={handleSkipNav}
      />
      <IncomeCalculator t={props.t} />
      <Footer initialLanguage={props.locale} />
    </div>
  );
}

export default withTranslation()(App);
